import api from './api'

export const log = {
  logPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/LogPageList`, params)
  },
  lcdlogPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/LCDLogPageList`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/log.js